module.exports = __webpack_public_path__ + "4e4a1f45a320c9a18b9203a8bfe517fc.png";